import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/dashboard");
    }

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    // const [loggedIn, setLoggedIn] = useState(false);

    // const handleLogin = () => {
    //     if (username && password) {
    //         setLoggedIn(true);
    //     }
    // };

    // Render the login form
    return (
        <div style={{ width: '300px', margin: 'auto', marginTop: '100px' }}>
        <h2>Login</h2>
        <Form>
            <Form.Item label="Username">
            <Input value={username} onChange={(e) => setUsername(e.target.value)} />
            </Form.Item>
            <Form.Item label="Password">
            <Input.Password value={password} onChange={(e) => setPassword(e.target.value)} />
            </Form.Item>
            <Form.Item>
            <Button type="primary" onClick={handleClick}>Login</Button>
            </Form.Item>
        </Form>
        </div>
    );
};

// Export the component
export default Login;